import React from 'react'
import { BannerBottom } from './elements/BannerBottom'
import { LargeBanner } from '../../catalog/banner/LargeBanner'
import styled from 'styled-components'
import { FatTitle, LightTitle } from '../../catalog/text/Title'
import { PopupButton, PopupLinkButton } from '../../catalog/buttons/PopupButton'
import { useAccountState } from '../../../hooks/useAccountState'
import { MainBannerContent } from './elements/MainBannerContent'
import { EmptyLine } from '../../catalog/EmptyLine'
import { ArrowLinkIcon } from '../../catalog/icons/ArrowLinkIcon'
import { tabletSize } from '../../catalog/screen-sizes'
import { SecondarySwapLink } from '../../catalog/buttons/SwapLink'
import { BannerTitle } from './elements/BannerTitle'
import { claim } from '../../../api/waitlist/airtable'

export const PoolBannerPlaceHolder = () => {
  const { accountState, accountStateDispatcher } = useAccountState()
  const rank = accountState.waitlistState.rank

  return (
    <RelativeDiv>
      <LargeBanner>
        <EmptyLine size={2} />

        <BannerTitle>
          <LightTitle>Swaap v2 is now available to all!</LightTitle>
        </BannerTitle>

        <EmptyLine size={2} />
        <Buttons className={'buttons'}>
          <PopupLinkButton href={'https://app.swaap.finance'}>
            Go to v2 now!
          </PopupLinkButton>
        </Buttons>
        <EmptyLine />

        {/* <Buttons */}
        <EmptyLine size={1} />

        <BannerBottom />
      </LargeBanner>
    </RelativeDiv>
  )
}

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px;
  gap: 20px;

  a,
  button {
    width: 250px;
    white-space: nowrap;
  }

  @media (max-width: ${tabletSize}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 20px 30px;
    gap: 10px;
  }
`

const Title = styled.div`
  white-space: nowrap;
  margin-top: 40px;
`

const RelativeDiv = styled.div`
  position: relative;
  margin-left: 72px;
  margin-right: 72px;
  @media (max-width: ${tabletSize}) {
    margin-left: 20px;
    margin-right: 20px;
  }
`
